import { createAction } from '@reduxjs/toolkit';

import { SCREENS } from './routing';

export const navigateAction = createAction<SCREENS>('navigate');
